<template>
  <b-form-group style="position: relative" class="bushel-material-form mb-0" :class="{ 'input-is-invalid': error }">
    <div class="row">
      <div
        class="col-12 text-left"
        :class="{
          'text-center': centerLabel,
          'd-sm-none': colWrapSize == 'sm',
          'd-md-none': colWrapSize == 'md',
          'd-lg-none': colWrapSize == 'lg',
        }"
      >
        <label :class="[inputFocused || (value && value.length > 0) || (modelValue && modelValue.length > 0) ? 'label-focussed' : '']">{{
          labelActive
        }}</label>
      </div>
      <div
        class="col-4 text-right mt-2 d-none"
        :class="{
          labelColClass,
          'd-sm-block': colWrapSize == 'sm',
          'd-md-block': colWrapSize == 'md',
          'd-lg-block': colWrapSize == 'lg',
        }"
      >
        <label :class="{ 'label-focussed': inputFocused }">{{ labelActive }}</label>
      </div>
      <div class="col-12" :class="inputColClass">
        <b-input-group>
          <BInputGroupPrepend class="border-bottom">
            <div class="bushel__flag mt-2" :class="countries.find((c) => c.cc.toLowerCase() == country.toLowerCase()).cc.toLowerCase()"></div>
          </BInputGroupPrepend>
          <b-form-input
            id="flag-mask"
            v-maska
            :data-maska="countries.find((c) => c.cc.toLowerCase() == country.toLowerCase()).mask"
            :value="modelValue ? modelValue : value"
            :autocomplete="autocomplete"
            type="tel"
            :name="name"
            class="form-control"
            :class="{ 'is-invalid': error, 'text-center': centerInput, 'pl-3': prefix && prefix.length >= 1 }"
            @input="onInput"
            @focus="inputFocused = true"
            @blur="inputFocused = false"
          />
        </b-input-group>
        <span class="highlight" :class="{ 'highlight-focussed': inputFocused }" />
        <span class="bar" :class="{ 'bar-focussed': inputFocused }" />
        <!-- <label :class="{'center-label': centerLabel, 'label-fixed': labelFixed || (value && value.length >= 1) }">{{labelActive}}</label> -->
        <div v-if="prefix && prefix.length >= 1" class="input-prefix">
          {{ prefix }}
        </div>
        <div v-if="suffix && suffix.length >= 1" class="input-suffix">
          {{ suffix }}
        </div>
        <div v-if="appendIcon" class="append-icon" :class="appendIcon" @click="$emit('iconClicked')" />
        <div v-if="thin" class="thin-padding" />
        <div v-if="!thin" v-show="!error" class="feedback-spacer" :class="{ 'd-none': inputFocused }" />
        <b-form-invalid-feedback v-if="!thin" v-show="error" id="inputLiveFeedback" class="message hidden-overflow-vis">
          {{ errorText }}
        </b-form-invalid-feedback>
        <b-form-text v-if="!thin" v-show="!error" class="message hidden-overflow-vis" :class="{ 'd-none': !inputFocused }">
          {{ message }}
        </b-form-text>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import { vMaska } from "maska/vue";
import BFormGroup from "@/components/base/BFormGroup.vue";
import BFormInvalidFeedback from "@/components/base/BFormInvalidFeedback.vue";
import BFormText from "@/components/base/BFormText.vue";
import BInputGroupPrepend from "@/components/base/BInputGroupPrepend.vue";
import BInputGroup from "@/components/base/BInputGroup.vue";
import BFormInput from "@/components/base/BFormInput.vue";
import phoneMasks from "@/services/phoneMasks";

export default {
  components: {
    BFormGroup,
    BFormInvalidFeedback,
    BFormText,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
  },
  directives: { maska: vMaska },
  props: {
    labelColClass: { type: String },
    inputColClass: { type: String },
    colWrapSize: { type: String },
    country: { type: String, default: "us" },
    type: { type: String, default: "text" },
    name: { type: String },
    value: { type: null },
    modelValue: { type: null },
    message: { type: String },
    error: { type: Boolean },
    errorText: { type: String },
    labelActive: { type: String },
    suffix: { type: String },
    prefix: { type: String },
    appendIcon: { type: String },
    centerLabel: { type: Boolean, default: false },
    centerInput: { type: Boolean, default: false },
    labelFixed: { type: Boolean, default: false },
    thin: { type: Boolean, default: false },
    autocomplete: { type: String },
  },

  emits: ["update:modelValue", "input"],
  data: () => ({
    inputFocused: false,
    selectedCountry: null,
    countries: [],
  }),
  created() {
    this.countries = phoneMasks;
  },
  methods: {
    onInput(e) {
      this.$emit("update:modelValue", e);
      this.$emit("input", e);
    },
  },
};
</script>

<style scoped>
:deep(.vue-country-select) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0px;
  border-right: 0px;
  border-left: 0px;
  border-top: 0px;
}
:deep(.vue-country-select .dropdown-arrow) {
  display: none;
}

:deep(.vue-country-select:focus, .vue-country-select:focus-within, .vue-country-select .dropdown:focus) {
  border-color: #93a3bd;
  box-shadow: none;
  outline: none;
  background: transparent;
}

:deep(.vue-country-select .dropdown:hover) {
  background: transparent;
}

:deep(.vue-country-select .dropdown) {
  border-color: #93a3bd;
  box-shadow: none;
  outline: none;
  padding-bottom: 0.2em;
}

.input-is-invalid :deep(.vue-country-select) {
  border-bottom: 1px solid #ff5454;
}
</style>

<style scoped lang="scss">
@import "@sass/_variables.scss";

.form-group {
  padding-top: 20px;
  position: relative;
  margin-bottom: -1px;
  text-align: left !important;
}

label {
  left: 55px;
}

.label-focussed {
  left: 20px;
  top: -9px !important;
}
</style>
